import { OutgoingPostbackStepLogTable } from "components/Tables/OutgoingPostbackStepLogTable/OutgoingPostbackStepLogTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/"
)({
    component: OutgoingPostbackStepLogPage,
    staticData: {
        permissions: [PermissionEnum.StepLogOutgoingPostbacksView],
        showInSideMenu: false,
        label: "pages.log.tracking.to-steps.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.tracking.to-steps.title"),
        };
    },
});

function OutgoingPostbackStepLogPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <OutgoingPostbackStepLogTable />
        </TenantPage>
    );
}
